import { FormController } from '@form-ts/core';
import { SagaIterator } from 'redux-saga';
import { formSubmitFailure } from 'src/modules/form/sagas/utils/formSubmitFailure';
import { FormError } from 'src/modules/form/types/FormError';
import { FormRule } from 'src/modules/form/types/FormRule';
import { validate } from 'src/modules/form/utils/validate';
import { call } from 'typed-redux-saga';

export function* formValidate<T>(
  form: FormController<T, FormError>,
  rule: FormRule<T>,
): SagaIterator<boolean> {
  const values = form.values.get(form.currentState);

  const errors = yield* call(validate, values, rule);
  if (Object.keys(errors).length === 0) {
    return true;
  }

  yield* call(formSubmitFailure, form, errors);
  return false;
}
